"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemsService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class ItemsService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetchItems(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = payload.onlyInventoryItems ?
                    `${this.baseUrl}hotel_billing/menu_items/list?page=${payload.pageNumber}&limit=${payload.limit}&outlet_id=${payload.outlet_id}&onlyInventoryItems=${payload.onlyInventoryItems}` :
                    `${this.baseUrl}hotel_billing/menu_items/list?page=${payload.pageNumber}&limit=${payload.limit}&outlet_id=${payload.outlet_id}`;
                if (payload.itemListId) {
                    url = url + `&item_list_id=${payload.itemListId}`;
                }
                const response = yield axios_1.default.get((url = url), {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const respData = response.data.data;
                return respData;
            }
            catch (error) {
                throw new Error("Error in fetching items");
            }
        });
    }
    createItem(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/menu_items/create`;
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.post((url = url), payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error("Error in creating item");
            }
        });
    }
    updateItem(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/menu_items/edit`;
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.put((url = url), payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error("Error in updating item");
            }
        });
    }
    searchItems(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = payload.onlyInventoryItems ?
                    `${this.baseUrl}hotel_billing/menu_items/search?page=${payload.pageNumber}&query=${payload.searchQuery}&limit=${payload.limit}&outlet_id=${payload.outlet_id}&onlyInventoryItems=${payload.onlyInventoryItems}` :
                    `${this.baseUrl}hotel_billing/menu_items/search?page=${payload.pageNumber}&query=${payload.searchQuery}&limit=${payload.limit}&outlet_id=${payload.outlet_id}`;
                const response = yield axios_1.default.get((url = url), {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const respData = response.data.data;
                return respData;
            }
            catch (error) {
                throw new Error("Error in searching items");
            }
        });
    }
    importItems(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/menu_items/import`;
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.post((url = url), payload, {
                    headers: header,
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error("Error in importing items");
            }
        });
    }
}
exports.ItemsService = ItemsService;
